var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"10","height":"7","viewBox":"0 0 10 7","fill":"none"}},[_c('path',{attrs:{"d":"M8.75 0.75L3.59375 6L1.25 3.61364","stroke":_vm.fill,"stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }